<template>
    <span v-bind="$attrs" class="tag-third" :class="classes" :style="style">
        <slot></slot>
    </span>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true,
            validator(value) {
                return [
                    'contact',
                    'client',
                    'prospect',
                    'supplier',
                    'company',
                    'individual',
                    'archived',
                    'reference',
                    'custom',
                ].includes(value);
            },
        },
        size: {
            type: String,
            default: 'medium',
            validator(value) {
                return ['extra-small', 'small', 'medium', 'large'].includes(value);
            },
        },
        bgColor: {
            type: String,
            default: '',
        },
    },
    computed: {
        classes() {
            return [`tag-third--${this.type}`, `tag-third--${this.size}`, this.fontClass];
        },
        style() {
            return this.bgColor ? { backgroundColor: `var(--colors-${this.bgColor})` } : {};
        },
        fontClass() {
            switch (this.size) {
                case 'large':
                    return 'typographies-paragraph-large-semibold';
                case 'small':
                case 'extra-small':
                    return 'typographies-paragraph-small-semibold';
                default:
                    return 'typographies-paragraph-medium-semibold';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.tag-third {
    border: 1px solid;
    display: inline-block;
    font-family: var(--font-families-proxima-nova);

    &--contact {
        background-color: var(--colors-component-background-information-tag-directory-contact);
        border-color: var(--colors-component-border-tag-directory-contact);
        color: var(--colors-component-text-tag-directory-contact);
    }

    &--client {
        background-color: var(--colors-component-background-information-tag-directory-customer);
        border-color: var(--colors-component-border-tag-directory-customer);
        color: var(--colors-component-text-tag-directory-customer);
    }

    &--prospect {
        background-color: var(--colors-component-background-information-tag-directory-prospect);
        border-color: var(--colors-component-border-tag-directory-prospect);
        color: var(--colors-component-text-tag-directory-prospect);
    }

    &--supplier {
        background-color: var(--colors-component-background-information-tag-directory-supplier);
        border-color: var(--colors-component-border-tag-directory-supplier);
        color: var(--colors-component-text-tag-directory-supplier);
    }

    &--company {
        background-color: var(--colors-component-background-information-tag-directory-company);
        border-color: var(--colors-component-border-tag-directory-company);
        color: var(--colors-component-text-tag-directory-company);
    }

    &--individual {
        background-color: var(--colors-component-background-information-tag-directory-individual);
        border-color: var(--colors-component-border-tag-directory-individual);
        color: var(--colors-component-text-tag-directory-individual);
    }

    &--archived {
        background-color: var(--colors-component-background-information-tag-directory-archive);
        border-color: var(--colors-component-border-tag-directory-archive);
        color: var(--colors-component-text-tag-directory-archive);
    }

    &--reference {
        background-color: var(--colors-component-background-information-tag-grey);
        border-color: var(--colors-common-border-lighter);
        color: var(--colors-common-text-primary-default);
    }

    /* SIZE */
    &--large {
        border-radius: 54px;
        padding: var(--spacing-1) var(--spacing-3);
    }

    &--medium {
        border-radius: 54px;
        padding: 6px var(--spacing-3);
    }

    &--small {
        border-radius: 44px;
        padding: var(--spacing-0) var(--spacing-1);
    }

    &--extra-small {
        border-radius: 44px;
        padding: 0 var(--spacing-1);
    }
}
</style>
